export default "__VITE_ASSET__s4615eqx__"